import React from 'react';
import PropTypes from 'prop-types';
import MaterialCardText from 'material-ui/Card/CardText';

const CardText = (props) => {
    const {
        children,
        style,
    } = props;

    return (
        <MaterialCardText
            style={ style }
        >
            { children }
        </MaterialCardText>
    );
};

CardText.propTypes = {
    children: PropTypes.node.isRequired,
    style: PropTypes.object,
};

export default CardText;



// WEBPACK FOOTER //
// ./src/components/ui/card/CardText.js